import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { useLang } from "../LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export const FAQ = () => {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq" className="relative py-24 md:py-32 bg-[#050505]">
      <div className="max-w-[1000px] mx-auto px-5 md:px-10">
        <div className="mb-14 max-w-2xl">
          <Reveal><Eyebrow testId="faq-eyebrow">{t.faq.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl md:text-6xl text-white tracking-tight leading-[1.05]">
              {t.faq.title1} <span className="text-gold-gradient italic">{t.faq.title2}</span>
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-lg md:text-2xl text-white hover:text-[#d4af37] hover:no-underline py-6 [&>svg]:text-[#d4af37]"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-[#a3a3a3] text-base leading-relaxed pb-6 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
